module.exports = __webpack_public_path__ + "static/media/indexpage-img.dfad8ea1.png";